import styled from "styled-components";
import Label from "../label/label.component.js";
export const TitleContainer = styled(Label).withConfig({
  displayName: "titlestyles__TitleContainer",
  componentId: "sc-1phcrr1-0"
})([""]);
